<section class="mat-typography">
    <br />
    <h1>Teltonika Task Manager</h1>
</section>
<div class="padded-side-nav">
    <p>
        Using this feature you can create custom task scenarios, that can be executed at any time and for as many
        devices at once.<br>
        Each task group can consist of a lot of smaller tasks with different types, timeout intervals and acceptable
        return code configurations.
    </p>
    @if(finishedLoading){
    <tools-table [Headers]="tasksHeaders" [Data]="taskData" #table (SearchChange)="onSearchChange($event)"
        [Search]="true" [Add]="true" (AddChange)="onAddChange($event)" [SortColumn]="''" [Slim]="true"
        [Actions]="taskActions" [DynamicCount]="false">
    </tools-table>
    } @else {
    <mat-spinner [diameter]="40"></mat-spinner>
    }
</div>